import React from 'react';
import ReactSelect from 'react-select-plus';
import { createEvent } from '../helpers';

const Select = ({
  value,
  onChange,
  name,
  options = [],
  clearable = false,
  ...props
}) => {
  return (
    <ReactSelect
      id={name}
      value={value}
      options={options}
      onChange={({ value }) => onChange(createEvent({ name, value }))}
      clearable={clearable}
      {...props}
    />
  );
};

export default Select;
